<!-- 
    for refactor
    future updates - combine details with Overtime2.vue component - use only Overtime.vue  
    add mode:
        if accessing from My Attendance or if transDate exist, 
            then hide the trans date picker and display the trans date as label
        if transDate is null, display trans date picker
    if edit
        then hide the trans date picker and display the trans date as label
-->

<template>
    <v-form @submit.prevent="addEditOvertime" ref="form">
        <v-card dense class="rounded-4">
            <v-toolbar flat height="45px">
                <span class="font-weight-bold ">{{overtimeContext.mode}} Overtime</span>
                <v-spacer></v-spacer>
                <help-link appId="attendance" pageId="overtime-page" color="black"></help-link>
                <v-btn icon @click.native="closeDialog" :disabled="disabled">
                    <v-icon >close</v-icon>
                </v-btn>
            </v-toolbar>
            <v-alert v-if="isApproved" :value="true" color="warning" icon="warning" outline style="margin:5px 20px 0px 20px;">
                This is already approved. Clicking Save will update back to For Review.
            </v-alert>  
            <v-alert v-if="error" :value="true" color="error" icon="error" outline>
                Error encountered. Please contact support@sweldonow.ph. Error details {{ errorMessage }}
            </v-alert>
            <v-card-text :class="isMobile?'form-content-mobile':'form-content'">
                <v-layout row>
                    <v-flex xs12 sm12>
                        <v-menu v-model="menuTransDate" :close-on-content-click="false" :nudge-right="40"
                            lazy transition="scale-transition" offset-y full-width min-width="290px">
                            <template v-slot:activator="{ on }">
                                <v-text-field v-model="transDate" label="Date" readonly v-on="on" :rules="[rules.required]" :disabled="disabled"></v-text-field>
                            </template>
                            <v-date-picker no-title v-model="transDate" :allowed-dates="allowedDates" @input="menuTransDate=false"></v-date-picker>
                        </v-menu>
                    </v-flex>      
                </v-layout>
                <!-- <v-layout row>
                    <v-flex xs12 sm12>
                        <v-autocomplete
                            v-model="overtimeContext.projectId"
                            :disabled="disabled"
                            :items="project_list"
                            :loading="loading"
                            chips
                            color="primary lighten-2"
                            label="Project (optional)"
                            item-text="projectName"
                            item-value="projectId"
                            @change="setProjectTasks" 
                            >
                            <template v-slot:selection="data">
                                <v-chip :selected="data.selected" class="chip--select-multi">
                                    {{ data.item.projectName }}
                                </v-chip>
                            </template>
                            <template v-slot:item="data">
                                <template v-if="typeof data.item !== 'object'">
                                    <v-list-tile-content v-text="data.item"></v-list-tile-content>
                                </template>
                                <template v-else>
                                    <v-list-tile-content>
                                        <v-list-tile-title v-html="data.item.projectName"></v-list-tile-title>
                                        <v-list-tile-sub-title v-html="data.item.group"></v-list-tile-sub-title>
                                    </v-list-tile-content>
                                </template>
                            </template>
                        </v-autocomplete>
                    </v-flex>
                </v-layout>
                <v-layout v-if="overtimeContext.projectId" row>
                    <v-flex xs12 sm12>
                        <v-autocomplete
                            v-model="overtimeContext.projectTaskId"
                            :disabled="disabled"
                            :items="projecttask_list"
                            :loading="loading"
                            chips
                            color="primary lighten-2"
                            label="Task (optional)"
                            item-text="taskName"
                            item-value="projectTaskId"
                            >
                            <template v-slot:selection="data">
                                <v-chip :selected="data.selected" class="chip--select-multi">
                                    {{ data.item.taskName }}
                                </v-chip>
                            </template>
                            <template v-slot:item="data">
                                <template v-if="typeof data.item !== 'object'">
                                    <v-list-tile-content v-text="data.item"></v-list-tile-content>
                                </template>
                                <template v-else>
                                    <v-list-tile-content>
                                        <v-list-tile-title v-html="data.item.taskName"></v-list-tile-title>
                                        <v-list-tile-sub-title v-html="data.item.group"></v-list-tile-sub-title>
                                    </v-list-tile-content>
                                </template>
                            </template>
                        </v-autocomplete>
                    </v-flex>
                </v-layout> -->
                <v-layout row wrap>
                    <v-flex xs12 sm6 :class="isMobile?'':'pr-10'">
                        <v-menu
                            ref="menuClockStart"
                            v-model="menuClockStart"
                            :close-on-content-click="false"
                            :return-value.sync="timeClockStart"
                            lazy
                            transition="scale-transition"
                            offset-y
                        >
                            <template v-slot:activator="{ on }">
                            <v-text-field
                                v-model="timeClockStart"
                                label="Start Time"
                                readonly
                                v-on="on"
                                :rules="[rules.required]" 
                                @blur="computeTotalHours"
                                @change="computeTotalHours"
                            ></v-text-field>
                            </template>
                            <v-time-picker
                                v-if="menuClockStart"
                                v-model="timeClockStart"
                                :landscape="isMobile?false:true"
                                @click:minute="$refs.menuClockStart.save(timeClockStart)"
                            ></v-time-picker>
                        </v-menu>
                    </v-flex>
                    <v-flex xs12 sm6 :class="isMobile?'':'pl-10'">
                        <v-menu
                            ref="menuClockEnd"
                            v-model="menuClockEnd"
                            :close-on-content-click="false"
                            :return-value.sync="timeClockEnd"
                            lazy
                            transition="scale-transition"
                            offset-y
                        >
                            <template v-slot:activator="{ on }">
                            <v-text-field
                                v-model="timeClockEnd"
                                label="End Time"
                                readonly
                                v-on="on"
                                :rules="[rules.required]" 
                                @blur="computeTotalHours"
                                @change="computeTotalHours"
                            ></v-text-field>
                            </template>
                            <v-time-picker
                                v-if="menuClockEnd"
                                v-model="timeClockEnd"
                                :landscape="isMobile?false:true"
                                @click:minute="$refs.menuClockEnd.save(timeClockEnd)"
                            ></v-time-picker>
                        </v-menu>          
                    </v-flex>
                </v-layout>
                <v-layout row wrap>   
                    <v-flex xs12 sm6 :class="isMobile?'':'pr-10'">
                        <v-select
                            label="Charging Type"
                            :items="offsetOrPay_list"
                            :rules="[rules.required]" 
                            item-text="Description"
                            item-value="offsetOrPay"
                            :disabled="disabled"
                            v-model="overtimeContext.offsetOrPay"    
                            @change="setRateType"            
                        ></v-select>
                    </v-flex>
                    <v-flex xs12 sm6 :class="isMobile?'':'pl-10'">
                        <v-select
                            label="Rate Type"
                            :items="overtimeRateTypesOptions"
                            :rules="[rules.required]" 
                            item-text="description"
                            item-value="rateType"
                            :disabled="disabled||isTOIL"
                            v-model="overtimeContext.rateType"                  
                        ></v-select>
                    </v-flex>      
                </v-layout>
                <v-layout row wrap>
                    <v-flex xs12 sm6 :class="isMobile?'':'pr-10'">
                            <v-text-field label="Break time (in minutes)" 
                            v-model="overtimeContext.breakTime" 
                            :rules="[rules.required]" 
                            type="number"
                            mask="###"
                            @blur="computeTotalHours"
                        ></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm6 :class="isMobile?'':'pl-10'"></v-flex>
                </v-layout>
                <v-layout row class="form-row-hours">
                    <v-flex xs6 c:class="isMobile?'':'pr-10'">
                        Total Hours: <b>{{totalHours}}</b>
                    </v-flex>
                    <v-flex xs6 :class="isMobile?'':'pl-10'">
                        Chargeable Hours: <b>{{chargeableHours}}</b>
                    </v-flex>
                </v-layout>
                <v-layout row v-if="showComment" v-show="overtimeContext.mode=='Add'" class="mt-10"> 
                    <v-flex xs12>
                        <v-textarea v-model="overtimeContext.remarks" label="Remarks" rows="1" color="primary"></v-textarea>
                    </v-flex>      
                </v-layout>
            </v-card-text>  
            <v-divider></v-divider>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn icon @click="showComment=!showComment" title="Add Comment">
                    <v-icon>comment</v-icon>
                </v-btn>
                <v-btn v-if="overtimeContext.mode!='Edit'" @click="clearForm" :disabled="disabled">Clear</v-btn>
                <v-btn color="primary" type="submit" :loading="loading" :disabled="disabled||!chargeableHours" class="mr-20">
                    <span v-if="overtimeContext.mode=='Add'">Save</span>
                    <span v-if="overtimeContext.mode=='Edit'">Update</span>
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-form>
</template>
<script>

// import projectsApi from '@/api/projects'
import overtimeApi from '@/api/overtime'
import commonfn from '@/common/functions'
import overtimeRateTypes from '@/constants/overtime-rate-types'

export default {
    data () {
        return {
            overtimeRateTypes,
            error: false,
            errorMessage: '', 
            loading: false,
            disabled: false,
            error: false,       
            rules: {
                required: value => !!value || 'Required.',
                min: v => v.length >= 8 || 'Min 8 characters',
                counter: value => value.length <= 20 || 'Max 20 characters',
                email: value => {
                const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
                return pattern.test(value) || 'Invalid e-mail.'
                } 
            },
            offsetOrPay_list: [
                {offsetOrPay: 1, Description: "Time Off in Lieu (TOIL)"},
                {offsetOrPay: 2, Description: "Payroll (Paid Overtime)"}
            ],
            showComment: false,
            // project_list: [],
            // projecttask_list: [],        
            overtimeContext: null,
            menuClockStart: false,
            timeClockStart: null,
            menuClockEnd: false,
            timeClockEnd: null,
            breakTime: null,
            chargeableHours: null,
            startDate: new Date().toISOString().substr(0, 10),
            menuStartDate: false,
            endDate: new Date().toISOString().substr(0, 10),
            menuEndDate: false,
            totalHours: null,
            transDate: null,
            menuTransDate: false,
            cutoff: null
        }
    },
    components: {
        'help-link': () => import('@/components/Common/HelpLink'),
    },
    methods: {      
        setRateType() {
            if (this.isTOIL) {
                this.overtimeContext.rateType = 4   //this value will not change
            }else{
                if (this.notApplicableRateType) this.overtimeContext.rateType = null
                else this.overtimeContext.rateType = 1
            }
        },
        allowedDates(val) {
            return (this.$moment(this.cutoff.cutoffStart).format('YYYY-MM-DD') <= this.$moment(val).format('YYYY-MM-DD') &&
                    this.$moment(this.cutoff.cutoffEnd).format('YYYY-MM-DD') >= this.$moment(val).format('YYYY-MM-DD'))
        },
        computeTotalHours() {
            if (this.timeClockStart!=null && this.timeClockEnd!=null && this.overtimeContext.breakTime!=null) {
                var clockStart = this.$moment('1/1/1900 ' + this.timeClockStart)
                var clockEnd = this.$moment('1/1/1900 ' + this.timeClockEnd)

                if (clockStart<clockEnd) {

                var durationTotal = this.$moment.duration(this.$moment(clockEnd).diff(this.$moment(clockStart)))
                var durationChargeable = this.$moment.duration(this.$moment(clockEnd).add(-this.overtimeContext.breakTime,'m').diff(this.$moment(clockStart)))

                this.totalHours = `${durationTotal.hours()}:${durationTotal.minutes()}` 
                this.chargeableHours = `${durationChargeable.hours()}:${durationChargeable.minutes()}`  
             }else{
                //night shift - clockout is on the next day
                var clockEnd = this.$moment('1/2/1900 ' + this.timeClockEnd) //plus one day if night shift

                var durationTotal = this.$moment.duration(this.$moment(clockEnd).diff(this.$moment(clockStart)))
                var durationChargeable = this.$moment.duration(this.$moment(clockEnd).add(-this.overtimeContext.breakTime,'m').diff(this.$moment(clockStart)))

                this.totalHours = `${durationTotal.hours()}:${durationTotal.minutes()}` 
                this.chargeableHours = `${durationChargeable.hours()}:${durationChargeable.minutes()}`  
                }
            }
        },
        formatHours() {
            if (this.overtimeContext.hours!=null) {
                var test = parseFloat(this.overtimeContext.hours).toFixed(2);
                this.overtimeContext.hours = test
            }
        },
        // setProjectTasks() {
        //     var projectTaskDesc = ''
        //     var projectTasks = this.project_list.filter(x=>{
        //         return x.projectId == this.overtimeContext.projectId
        //     })[0] 
            
        //     if (projectTasks!=undefined) projectTaskDesc = projectTasks.projectTasks
        //     this.projecttask_list = projectTaskDesc
        // },
        closeDialog() {
            this.clearForm()
            this.$emit('update:dialogOvertime', false)
        },
        async setParams(data) {
            //if (this.project_list.length==0) await this.getProjects()

            this.overtimeContext = data
            this.cutoff = data.cutoff
        },
        async addEditOvertime() {         
            if (this.$refs.form.validate()) {
                try {
                    this.loading = true
                    this.disabled = true
                    
                    var data = {
                        overtimeId: 0,
                        transDate: this.transDate,
                        hours: this.overtimeContext.hours,
                        breakTime: this.overtimeContext.breakTime,
                        chargeableHours: this.chargeableHours,
                        offsetOrPay: this.overtimeContext.offsetOrPay,
                        // premiumOnly: this.overtimeContext.premiumOnly,
                        rateType: this.overtimeContext.rateType,
                        projectId: this.overtimeContext.projectId,
                        projectTaskId: this.overtimeContext.projectId ? this.overtimeContext.projectTaskId : null,
                        remarks: this.overtimeContext.remarks,
                        startTime: this.$moment(this.transDate).format('MM/DD/YYYY') + ' ' + this.timeClockStart,
                        endTime: this.$moment(this.transDate).format('MM/DD/YYYY') + ' ' + this.timeClockEnd
                    }

                    var response = await overtimeApi.add(data)

                    if (response && response.status == 200) {
                        this.loading = false
                        this.disabled = false                    
                        this.closeDialog()
                        this.$emit('send', '')
                    }
                }
                catch(error) {
                    this.errorMessage = error
                    this.error = true
                }        
            }
        }, 
        // async getProjects() {
        //     try{
        //         this.error = false
        //         this.loading = true
                
        //         //note, do not include admin projects such as Holiday, VL, SL, etc
        //         //those are from TimeOff only
        //         //for OT, must indicate the actual project/task employee has worked on
        //         //the system will automatically detects OT rates based on date/time
        //         const response = await projectsApi.get()
        //         if (response && response.status == 200) {   
        //             this.project_list = response.data.items 
        //             // if (response.data.items.length) {
        //             //     response.data.items.forEach(p => {
        //             //         this.project_list.push(
        //             //             {
        //             //                 projectId: p.projectId,
        //             //                 projectName: `[${p.client}] ${p.projectCode} - ${p.projectName}`,
        //             //                 projectTasks: p.projectTasks
        //             //             }
        //             //         )
        //             //     })
        //             // }
        //         }

        //         this.disabled = false
        //         this.loading = false
        //     }catch(error){
        //         this.error = true
        //         this.errorMessage = error
        //     }
        // },
        clearForm() {
            this.$refs.form.reset()
            this.loading = false
            this.error = false
            this.totalHours = null
            this.chargeableHours = null
        }
    },
    computed: {
        isMobile() {
            return window.innerWidth < 600
        },
        isTOIL() {
            return this.overtimeContext.offsetOrPay == 1
        },
        isApproved() {
            return this.overtimeContext.status == commonfn.getStatusCode('Approved')
        },
        overtimeRateTypesOptions() {
            if (this.isTOIL) return this.overtimeRateTypes
            else return this.overtimeRateTypes.filter(x => x.paidOption)
        },
        notApplicableRateType() {
            return this.overtimeContext.rateType == 4 //this value will not change
        }
    },
  }
</script>
<style scoped>
.form-content {
    padding:10px 35px 10px 35px;
}
.form-content-mobile {
    padding:20px 40px 10px 40px;
}
.form-row-hours {
    margin:10px 0px 10px 0px;
}
</style>